export default "__VITE_ASSET__bD2SHdqQ__"